import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function File({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>File</title>
      <path
        d="M13.5 3L14.0363 2.47566C13.8951 2.33135 13.7018 2.25 13.5 2.25V3ZM19 8.625H19.75C19.75 8.42901 19.6733 8.2408 19.5363 8.10066L19 8.625ZM5.75 18V6H4.25V18H5.75ZM8 3.75H12V2.25H8V3.75ZM12 3.75H13.5V2.25H12V3.75ZM19.5363 8.10066L14.0363 2.47566L12.9637 3.52434L18.4637 9.14934L19.5363 8.10066ZM14.5 9.375H19V7.875H14.5V9.375ZM14.25 7.625V3H12.75V7.625H14.25ZM16 20.25H8V21.75H16V20.25ZM18.25 8.625V18H19.75V8.625H18.25ZM4.25 18C4.25 20.0711 5.92893 21.75 8 21.75V20.25C6.75736 20.25 5.75 19.2426 5.75 18H4.25ZM14.5 7.875C14.3619 7.875 14.25 7.76307 14.25 7.625H12.75C12.75 8.5915 13.5335 9.375 14.5 9.375V7.875ZM16 21.75C18.0711 21.75 19.75 20.0711 19.75 18H18.25C18.25 19.2426 17.2426 20.25 16 20.25V21.75ZM5.75 6C5.75 4.75736 6.75736 3.75 8 3.75V2.25C5.92893 2.25 4.25 3.92893 4.25 6H5.75Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M9 13H15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 17H15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
